import TopRatingSection from './TopRatingSection.component';
export default TopRatingSection;